const publishing = [
    {
        path: '/publishing',
        name: 'publishing',
        component: () => import('../views/publishing/index.vue')
    },
   
]

export default publishing